module.exports = __webpack_public_path__ + "static/media/2.7347fc2a.jpg";